function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/@babel/runtime/helpers/inheritsLoose.js
// module id = 1054
// module chunks = 2 4 5